<template>
  <div class="footer">
    <div v-if="!hideBrandName" class="child">
      &#169; Rakuten India
      <!-- privacy policy section removed temporarily -->
      <!-- <span class="privacy">
        Privacy Policy
      </span> -->
    </div>
  </div>
</template>
<script>
import BuildConfig from '@/environment';

export default {
  computed: {
    hideBrandName() {
      return BuildConfig.VUE_APP_DISABLE_ICON === 'true';
    }
  }
};
</script>
<style lang="scss" scoped>
.footer {
  font-size: 0.75em;
  margin-top: 0.875em;
  margin-bottom: 0.875em;
}
.child {
  width: 15.825em;
  background-color: $bg-primary;
  margin: 0 auto;
}
// .privacy {
//   text-decoration: underline;
//   cursor: pointer;
// }
</style>
